import React from 'react';
import RegistreAppelRoot, {
  RedirectToCurrentDay,
} from 'containers/RegistreAppel/index';
import { PageTrackerWrapper } from 'queries/user/track';
import Stats from 'containers/RegistreAppel/Stats/Loadable';
import List from 'containers/RegistreAppel/List/Loadable';
import { TitleHelmet } from 'components/TitleHelmet/TitleHelmet';
import { RegistreAppelPreview } from 'containers/RegistreAppel/Preview/Registre';
import { AppelsStatsPreview } from 'containers/RegistreAppel/Preview/Stats';

export const RegistreAppelRoutes = {
  path: 'registre-appel',
  children: [
    {
      element: (
        <>
          <TitleHelmet titleKey="sidebar.eleves.registreAppel" />
          <RegistreAppelRoot />
        </>
      ),
      children: [
        {
          path: 'stats',
          element: (
            <PageTrackerWrapper title="Registre d'appel - statistiques">
              <Stats />
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'appels/:year/:month/:day',
          element: (
            <PageTrackerWrapper title="Registre d'appel">
              <List />
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'appels',
          element: <RedirectToCurrentDay />,
        },
        {
          index: true,
          element: <RedirectToCurrentDay />,
        },
      ],
    },
    {
      path: 'appels/:year/:month/:day/preview',
      element: (
        <PageTrackerWrapper title="Registre d'appel - preview">
          <RegistreAppelPreview />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'stats/preview',
      element: (
        <PageTrackerWrapper title="Registre d'appel - statistiques - preview">
          <AppelsStatsPreview />
        </PageTrackerWrapper>
      ),
    },
  ],
};
